import  api  from './api';

const config = {
    headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Credentials': false
    }
}

export const getWorkflow = async () => {
    let workflow = null;
    try {
        const response = await api.get(`workflow/step/listcontroller`, config);
        workflow = response.data.data;
    } catch (err) {}
    return workflow;
}